"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var vendor_1 = tslib_1.__importDefault(require("../../system/vendor"));
var state_1 = tslib_1.__importDefault(require("../../system/state"));
var inputs_1 = require("../../../components/formsets/inputs");
var validation_1 = require("../../../util/resources/validation");
var PurchaseOrderResource = /** @class */ (function (_super) {
    tslib_1.__extends(PurchaseOrderResource, _super);
    function PurchaseOrderResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PurchaseOrderResource.related = function () {
        return tslib_1.__assign({}, index_1.BaseTransactionResource.related(), { vendor: vendor_1.default, state: state_1.default });
    };
    Object.defineProperty(PurchaseOrderResource.prototype, "remaining", {
        get: function () {
            return this.attributes.remaining;
        },
        enumerable: true,
        configurable: true
    });
    PurchaseOrderResource.endpoint = '/pos';
    PurchaseOrderResource.MODEL_NAME = 'purchaseorder';
    PurchaseOrderResource.LINE_CLASS = require('./lines').default;
    PurchaseOrderResource.validation = validation_1.extendValidators(index_1.BaseTransactionResource, {
        amount_decimal: validation_1.isValidCurrency('amount_decimal'),
        vendor: validation_1.isRequired('vendor')
    });
    PurchaseOrderResource.defaultFormset = {
        number: new inputs_1.inputs.DefaultInput('Number'),
        vendor: new inputs_1.inputs.PrimaryKeyInput('Vendor', 'name'),
        batch: new inputs_1.inputs.PrimaryKeyInput('Batch', 'name'),
        period: new inputs_1.inputs.PrimaryKeyInput('Period', 'name'),
        amount_decimal: new inputs_1.inputs.CurrencyInput('Amount'),
        date: new inputs_1.inputs.DateInput('Date'),
        effective_date: new inputs_1.inputs.DateInput('Effective Date'),
        description: new inputs_1.inputs.DefaultInput('Description'),
        time_posted: new inputs_1.inputs.DateInput('Time Posted'),
        expiration: new inputs_1.inputs.DateInput('Expiration'),
    };
    return PurchaseOrderResource;
}(index_1.BaseTransactionResource));
exports.default = PurchaseOrderResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/po/index.js
// module id = S3qK
// module chunks = 0